import { environmentBase } from "./environment.base";
const BasePath: string = "https://webapps.acep.org";
const BasePath_SEMPA: string = "https://webapps.sempa.org";
const ShoppingCartToken: string = 'Basic YXN0dXRldGVjaC5jb206YTBwczlldDFjbzJhbA==';
const PrivateWebServicesBasePath: string = "https://ws.acep.org/privatetoolkit";
export const environment = {
  base: environmentBase,
  localbase: BasePath,
  emgroupsearchapiendpoint: PrivateWebServicesBasePath + "/api/emgroupsearchapi/",
  contactapiendpoint: PrivateWebServicesBasePath + "/api/contactapi/",
  dashboardapiendpoint: PrivateWebServicesBasePath + "/api/dashboardapi/",
  groupportalapiendpoint: PrivateWebServicesBasePath + "/api/acepmemberappapi/",
  ninjaapiendpoint: BasePath + "/utils/api/ninja/",
  checkoutToken: ShoppingCartToken,
  s3endPoint: BasePath + "/utils/api/s3/",
  loginurl: BasePath + "/SAML/sso.ashx?" + "org=ACEP&redir=",
  logouturl: BasePath + "/Logout.aspx",
  production: true,
  env: "prod"
};
